import styled from 'styled-components';
import { Avatar } from '@material-ui/core';

const largeAvatar = styled(Avatar)`
  width: 60px !important;
  height: 60px !important;
`;

export default largeAvatar;
